import { IsNotEmpty } from 'class-validator';
import { Expose } from 'class-transformer';

export enum ServicePriceType {
  M3 = 'M3',
  UNIT = 'UNIT',
  MG = 'MG',
  HOUR = 'HOUR',
}

export enum Currency {
  EUR = 'EUR',
}

export enum ServicePriceBearer {
  ORGANIZATION_COST = 'ORGANIZATION_COST',
  ORGANIZATION_REVENUE = 'ORGANIZATION_REVENUE',
}

export class ServicePrice {
  @Expose()
  @IsNotEmpty()
  price?: number;

  @Expose()
  priceType?: ServicePriceType;

  @Expose()
  @IsNotEmpty()
  currency?: Currency;

  @Expose()
  @IsNotEmpty()
  bearer?: ServicePriceBearer;

  @Expose()
  comment?: string;

  @Expose()
  navResourceId?: string;
}
